<template>
  <div
    v-select-test-parts
    :data-testid="selectTestId('select')"
  >
    <v-select
      ref="countrycodesselect"
      :label="(selectType === '' ? $t('CountryCode') : $t('Country')) + (required ? ' *' : '')"
      :items="countryCodes"
      :rules="required ? [(v) => !!v || $t('RequiredField')] : []"
      :value="selectedCountry"
      :disabled="disabled"
      @change="handleChange"
    >
      <template #item="{ item }">
        <v-list-item-content :data-testid="selectTestId('option', item.value || 'none')">
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>
<script>
import internalApiClient from '../../api/internal-client'
import { testIdFor, selectTestParts } from '../../util/testId'
export default {
  name: 'CountryCodeSelector',
  directives: { selectTestParts },
  props: {
    selectedCountry: {
      type: String,
      required: false,
      default() {
        return ''
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    required: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    selectType: {
      type: String,
      required: false,
      default() {
        return ''
      },
    },
    /**
     * Base data-testid: the select gets '<testId>-select', options '<testId>-option-<value>'
     */
    testId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      countryCodes: [],
      rawCountryData: [],
    }
  },
  async mounted() {
    try {
      const response = await internalApiClient.getCountry()
      this.rawCountryData = response.data.data
      this.countryCodes = response.data.data.map((item) => {
        const textDescription = this.selectType === '' ? item.name : this.$t(item.fullName)
        return { text: textDescription, value: item.name }
      })
      if (!this.required) {
        this.countryCodes.unshift({ text: '', value: '' })
      }
    } catch (error) {
      this.countryCodes = []
    }
  },

  methods: {
    selectTestId(...parts) {
      return testIdFor(this.testId, ...parts)
    },
    /**
     * Returns selection value
     */
    getValue() {
      return this.$refs.countrycodesselect.internalValue
    },
    setValue(value) {
      this.$refs.countrycodesselect.internalValue = value
    },
    handleChange(value) {
      this.$emit('select-countrychange', value)
    },
    /**
     * Returns the country ID for a given country code
     */
    getCountryId(countryCode) {
      const country = this.rawCountryData?.find(item => item.name === countryCode)
      return country ? country.id : null
    },
  },
}
</script>

